import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../base/Icon";
import { usePlanNotice } from "../../core/Global";
import { DrawerFormRef } from "../drawers/DrawerForm";
import CancelChangeDrawer from "./CancelChangeDrawer";
import "./PlanNoticePill.css";


// The persistent banner of wireframe A6, carried in the header so it is on every screen: "Your
// plan changes to Pro on 12 Oct" with a button to cancel the change, a pause on its way, or an
// account that is paused and read-only, with the way back.
export default function PlanNoticePill() {

    const navigate = useNavigate()
    const notice = usePlanNotice()
    // Cancelling a scheduled change is confirmed in a drawer first, the same one the
    // subscription page opens, so the two never ask differently.
    const [cancelOpen, cancelOpenSet] = useState<boolean>(false)
    const cancelRef = useRef<DrawerFormRef>(null)

    if (!notice?.text) return null

    const onHold = notice.kind === "onhold"

    const act = () => {
        if (onHold) {
            navigate("/system/finance/subscription?resume=1")
            return
        }

        cancelOpenSet(true)
    }

    return (
        <>
        {
            cancelOpen &&
            <CancelChangeDrawer
                kind={notice.kind}
                currentPlanName={notice.currentPlanName}
                pendingPlanName={notice.planName}
                effectiveAt={notice.date}
                drawerRef={cancelRef}
                onCancelled={() => cancelRef.current?.close()}
                onClose={() => cancelOpenSet(false)} />
        }
        <div className={"plan-notice-pill" + (onHold ? " is-hold" : "")}>
            <Icon icon={onHold ? "lock" : notice.kind === "hold" ? "pause" : notice.kind === "upgrade" ? "arrow-up-right-dots" : "arrow-down-right"} type="solid" size={11} />
            <span className="plan-notice-pill-text" onClick={() => navigate("/system/finance/subscription")}>
                {notice.text}
            </span>
            {
                notice.action &&
                <button type="button" className="plan-notice-pill-action" onClick={e => { e.preventDefault(); act(); }}>
                    {notice.action}
                </button>
            }
        </div>
        </>
    )
}
